import React from "react";
import { Caption1 } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";

export const TemplateTaskPanelItem = ({ label, children, invalid }) => {
  return (
    <div className="tw-mb-6">
      <Caption1
        weight="bold"
        className={classNames("tw-mb-1", { "tw-text-red-alert": invalid })}
      >
        {label}
      </Caption1>
      {children}
    </div>
  );
};

TemplateTaskPanelItem.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  invalid: PropTypes.bool,
};

TemplateTaskPanelItem.defaultProps = {
  invalid: false,
};
